module.exports = "query referralDetails{referralDetails{numOfReferrals availableReferralCredit redeemedUsers{email}referralShortUrl}}"